var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFulfilledIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24392 0C3.24962 0 0 3.3645 0 7.5C0 11.6355 3.24962 15 7.24392 15C11.2382 15 14.4878 11.6355 14.4878 7.5C14.4878 6.6555 14.3458 5.84565 14.0959 5.0874L12.923 6.30176C12.9991 6.68876 13.0391 7.08975 13.0391 7.5C13.0391 10.8082 10.4392 13.5 7.24392 13.5C4.04862 13.5 1.44878 10.8082 1.44878 7.5C1.44878 4.19175 4.04862 1.5 7.24392 1.5C8.42685 1.5 9.52714 1.87042 10.4457 2.50342L11.4827 1.42969C10.2889 0.534188 8.82671 0 7.24392 0ZM13.9757 0.969727L6.51953 8.68945L4.13413 6.21973L3.10979 7.28027L6.51953 10.8105L15 2.03027L13.9757 0.969727Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFulfilledIcon);
export default __webpack_public_path__ + "static/media/fulfilledIcon.f6b7927d705c87ca150cd97fef2edaf0.svg";
export { ForwardRef as ReactComponent };